import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { Connector, UpdateConnectorRequest } from '@/entities/connector/types';

export const updateConnectorApi = async (id: string, request: UpdateConnectorRequest): Promise<Connector> => {
  const { data } = await connectorApiClient.patch<Connector>(`/connectors/${id}/config`, request);
  return data;
};
